var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatBubble = function SvgChatBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.083 19.724V5.782q0-.631.438-1.07a1.45 1.45 0 0 1 1.069-.437h12.82q.631 0 1.07.438.436.438.437 1.069v9.487q0 .63-.438 1.069a1.45 1.45 0 0 1-1.069.437H7.032zM6.5 15.525h11.91a.25.25 0 0 0 .176-.08.25.25 0 0 0 .08-.176V5.782a.25.25 0 0 0-.08-.176.25.25 0 0 0-.176-.08H5.59a.25.25 0 0 0-.176.08.25.25 0 0 0-.08.176v10.897z"
  })));
};
export default SvgChatBubble;